import { getGuestLocaleFromStorage } from './resolve-locale';
import { STORAGE_KEY_GUEST_LOCALE } from './constants';
import { setAppLocale } from './index';

/** 监听跨应用 / 跨标签页语言变更 */
export function installLocaleCrossAppSync() {
  function syncFromSharedStorage() {
    var saved = getGuestLocaleFromStorage();
    if (!saved) {
      return;
    }
    try {
      if (window.vbus && window.vbus.$i18n && window.vbus.$i18n.locale === saved) {
        return;
      }
    } catch (e) {
      // vbus may be unavailable during early bootstrap
    }
    setAppLocale(saved, { persistGuest: false });
  }

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY_GUEST_LOCALE) {
      syncFromSharedStorage();
    }
  });

  window.addEventListener('focus', syncFromSharedStorage);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      syncFromSharedStorage();
    }
  });
}
